import React from 'react';
import PropTypes from 'prop-types';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import PersonIcon from '@material-ui/icons/Person';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Paper from '@material-ui/core/Paper';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';

import './productList.less';

class ProductsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deletingProduct: null,
    };
  }

  startDeletionProcess = deletingProduct => {
    this.setState({ deletingProduct });
  }

  cancelDeletionProcess = () => {
    this.setState({ deletingProduct: null });
  }

  delete = () => {
    const { deletingProduct } = this.state;
    const { onDelete } = this.props;
    onDelete(deletingProduct);

    this.cancelDeletionProcess();
  }

  renderDeletionConfirmationDialog = () => {
    const { deletingProduct } = this.state;

    if (!deletingProduct) {
      return null;
    }

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xs"
        aria-labelledby="confirmation-dialog-title"
        open
      >
        <DialogTitle id="confirmation-dialog-title">Usuwanie produktu</DialogTitle>
        <DialogContent dividers>
          Czy na pewno chcesz usunąć produkt:
          {' '}
          {deletingProduct.name}
          ?
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={this.cancelDeletionProcess} color="primary">
            Nie
          </Button>
          <Button onClick={this.delete} color="primary">
            Tak
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const { products } = this.props;

    return (
      <Paper className="product-list">
        {this.renderDeletionConfirmationDialog()}

        <List>
          {products.map(product => (
            <ListItem key={product.name} className="product-list-item">
              <ListItemAvatar>
                {product.isForOnlyIndividualCustomer ? <PersonIcon /> : <div />}
              </ListItemAvatar>
              <ListItemText
                primary={product.name}
              />
              <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="delete" onClick={() => this.startDeletionProcess(product)}>
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Paper>
    );
  }
}

ProductsList.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ).isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default ProductsList;
